import { Fail } from './fail';

export class AbortFail extends Fail {
  _message = 'Operation was canceled';
}
